import React, { useMemo } from 'react';
import { HubBasePage } from '../../../../../types';
import { DiscoveryContentTypes } from '../../../../../constants';
import { useRootSelector } from '../../../../../store/hooks';
import { selectAudienceHubPage } from '../../store/features/page';
import { selectAudienceHubOptions } from '../../store/features/options';
import {
  DiscoveryStreamlyVideo,
  selectHubDiscoveryFacets,
  selectHubDiscoveryStreamlyVideosRecord,
  HubPageNames,
} from '../../../../../store/features/discovery';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import VideoCard from '../../../shared/productFilter/cards/VideoCard';
import { AggregatedProductPage } from '../../../shared/siteBuilder/AggregatedProductPage';
import StreamlyVideoModal from '../../../shared/StreamlyVideoModal';
import { useStreamlyVideoParams } from '../../../shared/hooks';

export function StreamlyVideos() {
  const { params, handleCleanParams, handleUpdateParams } =
    useStreamlyVideoParams();
  const {
    data: {
      page: {
        details: { title, description, metaDescription, searchQueryData },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectAudienceHubPage<HubBasePage>());

  const heading = title || 'Streamly Videos';

  const {
    data: { name: hubName, l2Topic: topicName },
  } = useRootSelector(selectAudienceHubOptions);
  const record = useRootSelector((state) =>
    selectHubDiscoveryStreamlyVideosRecord(state),
  );
  const facets = useRootSelector(selectHubDiscoveryFacets);

  const defaultValues = useMemo(
    () => ({
      sectors: [],
      topics: [],
      accessTypes: [],
      createdTimeFrame: [],
      mainFilterTopic: topicName,
      page: 1,
      count: 20,
      searchInput: '',
      type: [DiscoveryContentTypes.STREAMLY_VIDEO],
    }),
    [topicName],
  );

  return (
    <PageLayout>
      <MetaTags
        title={heading}
        titleSuffix={hubName}
        description={metaDescription}
        thumbnail={brandLogo?.path}
      />
      <AggregatedProductPage<DiscoveryStreamlyVideo>
        pageName={HubPageNames.streamlyVideos}
        contentType={DiscoveryContentTypes.STREAMLY_VIDEO}
        title={heading}
        subtitle={description}
        facets={facets}
        record={record}
        renderProduct={(product) => (
          <VideoCard
            data={product}
            cardType="list"
            onOpen={handleUpdateParams}
          />
        )}
        defaultValues={defaultValues}
        searchQueryData={searchQueryData}
      />
      {params && (
        <StreamlyVideoModal
          open={!!params}
          videoParams={params}
          onClose={handleCleanParams}
        />
      )}
    </PageLayout>
  );
}
